import { api } from '@/plugins/api';
import type { ApiLoginRequestI, UpdatePasswordRequestI } from './store';

export function login(loginRequest: ApiLoginRequestI | undefined) {
	return api.post(`/auth/login`, loginRequest);
}
export function logout() {
	return api.post(`/auth/logout`);
}
export function updatePassword(updatePasswordRequest: UpdatePasswordRequestI) {
	return api.post(`/auth/updatePassword`, updatePasswordRequest);
}
